import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Youtube } from 'lucide-react';
import { ProofSection } from '../components/ProofSection';
import { Navigation } from '../components/Navigation';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
// Video data structure - replace with actual YouTube video IDs
const poomsaeVideos = [{
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #1'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #2'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #3'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #4'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #5'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #6'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #7'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOSAE TAEGEUK II CHANG #8'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOMSAE KORYO 1ST DAN BLACK BELT'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOMSAE KEUMGANG 2ND DAN BLACK BELT'
}, {
  id: 'dQw4w9WgXcQ',
  title: 'NWBBA POOMSAE TAEBECK 3RD DAN BLACK BELT'
}];
const tutorialVideos = [{
  id: 'dQw4w9WgXcQ',
  title: 'How to Tie Your Belt'
}];
const rulesVideos = [{
  id: 'dQw4w9WgXcQ',
  title: "Children's Home Rules"
}];
interface VideoCardProps {
  videoId: string;
  title: string;
}
function VideoCard({
  videoId,
  title
}: VideoCardProps) {
  return <motion.div variants={fadeIn} className="group" data-id="element-394">
      <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden shadow-lg" data-id="element-395">
        <iframe src={`https://www.youtube.com/embed/${videoId}`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-396" />
      </div>
      <h3 className="mt-3 text-sm font-bold text-[#1e3a8a] uppercase tracking-wide" data-id="element-397">
        {title}
      </h3>
    </motion.div>;
}
export function ResourcesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-398">
      <Navigation data-id="element-399" />

      {/* Hero Section */}
      <section className="relative py-20 px-4 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] text-white overflow-hidden" data-id="element-400">
        <div className="absolute inset-0 opacity-10" data-id="element-401">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')]" data-id="element-402"></div>
        </div>
        <div className="max-w-6xl mx-auto text-center relative" data-id="element-403">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-404">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-405">
              <Youtube className="w-12 h-12" data-id="element-406" />
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mb-4" data-id="element-407">
              Resource Videos
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed" data-id="element-408">
              Master your techniques with our comprehensive video library.
              Practice at home and perfect your forms.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Poomsae Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-409">
        <div className="max-w-7xl mx-auto" data-id="element-410">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-411">
            <div className="text-center mb-12" data-id="element-412">
              <h2 className="text-3xl sm:text-4xl font-black text-[#1e3a8a] mb-4" data-id="element-413">
                POOMSAE
              </h2>
              <div className="w-24 h-1 bg-[#dc2626] mx-auto rounded-full mb-4" data-id="element-414"></div>
              <p className="text-gray-600 text-lg" data-id="element-415">
                Learn and practice traditional Taekwondo forms
              </p>
            </div>

            <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-416">
              {poomsaeVideos.map((video, idx) => <VideoCard key={idx} videoId={video.id} title={video.title} data-id="element-417" />)}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* How to Tie Your Belt Section */}
      <section className="py-20 px-4 bg-white" data-id="element-418">
        <div className="max-w-7xl mx-auto" data-id="element-419">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-420">
            <div className="text-center mb-12" data-id="element-421">
              <h2 className="text-3xl sm:text-4xl font-black text-[#1e3a8a] mb-4" data-id="element-422">
                HOW TO TIE YOUR BELT
              </h2>
              <div className="w-24 h-1 bg-[#dc2626] mx-auto rounded-full mb-4" data-id="element-423"></div>
              <p className="text-gray-600 text-lg" data-id="element-424">
                Master the proper way to tie your belt
              </p>
            </div>

            <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="max-w-2xl mx-auto" data-id="element-425">
              {tutorialVideos.map((video, idx) => <VideoCard key={idx} videoId={video.id} title={video.title} data-id="element-426" />)}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Children's Home Rules Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-427">
        <div className="max-w-7xl mx-auto" data-id="element-428">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-429">
            <div className="text-center mb-12" data-id="element-430">
              <h2 className="text-3xl sm:text-4xl font-black text-[#1e3a8a] mb-4" data-id="element-431">
                CHILDREN'S HOME RULES
              </h2>
              <div className="w-24 h-1 bg-[#dc2626] mx-auto rounded-full mb-4" data-id="element-432"></div>
              <p className="text-gray-600 text-lg" data-id="element-433">
                Important guidelines for students and parents
              </p>
            </div>

            <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="max-w-2xl mx-auto" data-id="element-434">
              {rulesVideos.map((video, idx) => <VideoCard key={idx} videoId={video.id} title={video.title} data-id="element-435" />)}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-[#1e3a8a] text-white text-center" data-id="element-436">
        <div className="max-w-3xl mx-auto" data-id="element-437">
          <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-438">
            Ready to Start Training?
          </h2>
          <p className="text-blue-100 mb-8 text-lg leading-relaxed" data-id="element-439">
            Use these videos to practice at home and accelerate your progress.
            Join us for live instruction and personalized feedback.
          </p>
          <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors" data-id="element-440">
            Start Your $29 Trial
          </Link>
        </div>
      </section>

      {/* Proof Section */}
      <ProofSection testimonialIndex={4} data-id="element-441" />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-442">
        <div className="max-w-4xl mx-auto" data-id="element-443">
          <div className="font-black text-xl text-white mb-4 tracking-tighter" data-id="element-444">
            NWBBA
          </div>
          <p className="mb-6" data-id="element-445">Northwest Black Belt Academy</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8" data-id="element-446">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-447">
              Home
            </Link>
            <Link to="/about" className="hover:text-white transition-colors" data-id="element-448">
              About
            </Link>
            <Link to="/classes" className="hover:text-white transition-colors" data-id="element-449">
              Classes
            </Link>
            <Link to="/schedule" className="hover:text-white transition-colors" data-id="element-450">
              Schedule
            </Link>
            <Link to="/resources" className="text-white font-bold" data-id="element-451">
              Resources
            </Link>
            <Link to="/blog" className="hover:text-white transition-colors" data-id="element-452">
              Blog
            </Link>
            <Link to="/proof" className="hover:text-white transition-colors" data-id="element-453">
              Proof
            </Link>
            <a href="#" className="hover:text-white transition-colors" data-id="element-454">
              Contact
            </a>
          </div>
          <p data-id="element-455">
            &copy; {new Date().getFullYear()} Northwest Black Belt Academy. All
            rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}